import { render, staticRenderFns } from "./ScheduleClassRow.vue?vue&type=template&id=253ebbc2&scoped=true"
import script from "./ScheduleClassRow.vue?vue&type=script&lang=js"
export * from "./ScheduleClassRow.vue?vue&type=script&lang=js"
import style0 from "./ScheduleClassRow.vue?vue&type=style&index=0&id=253ebbc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253ebbc2",
  null
  
)

export default component.exports